const actions = {
    GET_ACTIVATION_REPORT: "GET_ACTIVATION_REPORT",
    GET_ACTIVATION_REPORT_SUCCESS: "GET_ACTIVATION_REPORT_SUCCESS",
    GET_ACTIVATION_REPORT_FAILED: "GET_ACTIVATION_REPORT_FAILED",
    GET_TYPE_CODE: 'GET_TYPE_CODE',
    GET_TYPE_CODE_SUCCESS: 'GET_TYPE_CODE_SUCCESS',
    GET_TYPE_CODE_FAILED: "GET_TYPE_CODE_FAILED",

    getActivationReport: (searchData) => ({
        type: actions.GET_ACTIVATION_REPORT,
        payload: { searchData },
    }),
    getActivationReportSuccess: (activationResult) => ({
        type: actions.GET_ACTIVATION_REPORT_SUCCESS,
        payload: { activationResult }
    }),
    getActivationReportFailed: (error) => ({
        type: actions.GET_ACTIVATION_REPORT_FAILED,
        error
    }),

    getTypeCode: (data) => ({
        type: actions.GET_TYPE_CODE,
        payload: { data }
    }),
    getTypeCodeSuccess: (result) => ({
        type: actions.GET_TYPE_CODE_SUCCESS,
        result
    }),
    getTypeodeFailed: (error) => ({
        type: actions.GET_TYPE_CODE_FAILED,
        error
    }),
}

export default actions;